import { setAlertDetails } from "api";

export const OCCUPATIONS = [
  "Content Creator",
  "Influencer",
  "Social media manager",
  "Digital marketer",
  "Entrepreneur",
  "Marketing agency",
  "Other",
];

export const USAGE_INTENTIONS = [
  "I want to automate posting on multiple social media",
  "I want to analyze insights from all my social accounts",
  "I want to collaborate with my team",
  "I want PostPaddy to assist in content creation",
  "Other",
];

export const INDUSTRIES = [
  "Accounting",
  "Airlines/Aviation",
  "Alternative Dispute Resolution",
  "Alternative Medicine",
  "Animation",
  "Apparel & Fashion",
  "Architecture & Planning",
  "Arts and Crafts",
  "Automotive",
  "Aviation & Aerospace",
  "Banking",
  "Biotechnology",
  "Broadcast Media",
  "Building Materials",
  "Business Supplies and Equipment",
  "Capital Markets",
  "Chemicals",
  "Civic & Social Organization",
  "Civil Engineering",
  "Commercial Real Estate",
  "Computer & Network Security",
  "Computer Games",
  "Computer Hardware",
  "Computer Networking",
  "Computer Software",
  "Construction",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Services",
  "Cosmetics",
  "Dairy",
  "Defense & Space",
  "Design",
  "Digital Marketing",
  "E-Learning",
  "Education Management",
  "Electrical/Electronic Manufacturing",
  "Energy",
  "Entertainment",
  "Environmental Services",
  "Events Services",
  "Executive Office",
  "Facilities Services",
  "Farming",
  "Financial Services",
  "Fine Art",
  "Fishery",
  "Food & Beverages",
  "Food Production",
  "Fund-Raising",
  "Furniture",
  "Gambling & Casinos",
  "Glass, Ceramics & Concrete",
  "Government Administration",
  "Government Relations",
  "Graphic Design",
  "Health, Wellness and Fitness",
  "Higher Education",
  "Horticulture",
  "Hospital & Health Care",
  "Hospitality",
  "Human Resources",
  "Import and Export",
  "Individual & Family Services",
  "Industrial Automation",
  "Information Services",
  "Information Technology and Services",
  "Insurance",
  "International Affairs",
  "International Trade and Development",
  "Internet",
  "Investment Banking",
  "Investment Management",
  "Judiciary",
  "Law Enforcement",
  "Law Practice",
  "Legal Services",
  "Legislative Office",
  "Leisure, Travel & Tourism",
  "Libraries",
  "Logistics and Supply Chain",
  "Luxury Goods & Jewelry",
  "Machinery",
  "Management Consulting",
  "Maritime",
  "Market Research",
  "Marketing and Advertising",
  "Mechanical or Industrial Engineering",
  "Media Production",
  "Medical Devices",
  "Medical Practice",
  "Mental Health Care",
  "Military",
  "Mining & Metals",
  "Mobile Games",
  "Motion Pictures and Film",
  "Museums and Institutions",
  "Music",
  "Nanotechnology",
  "Newspapers",
  "Non-Profit Organization Management",
  "Online Media",
  "Outsourcing/Offshoring",
  "Package/Freight Delivery",
  "Packaging and Containers",
  "Paper & Forest Products",
  "Performing Arts",
  "Pharmaceuticals",
  "Philanthropy",
  "Photography",
  "Plastics",
  "Political Organization",
  "Primary/Secondary Education",
  "Printing",
  "Professional Training & Coaching",
  "Program Development",
  "Public Policy",
  "Public Relations and Communications",
  "Public Safety",
  "Publishing",
  "Railroad Manufacture",
  "Ranching",
  "Real Estate",
  "Recreational Facilities and Services",
  "Religious Institutions",
  "Renewables & Environment",
  "Research",
  "Restaurants",
  "Retail",
  "Security and Investigations",
  "Semiconductors",
  "Shipbuilding",
  "Social Media Management",
  "Sporting Goods",
  "Sports",
  "Staffing and Recruiting",
  "Supermarkets",
  "Telecommunications",
  "Textiles",
  "Think Tanks",
  "Tobacco",
  "Translation and Localization",
  "Transportation/Trucking/Railroad",
  "Utilities",
  "Venture Capital & Private Equity",
  "Veterinary",
  "Warehousing",
  "Wholesale",
  "Wine and Spirits",
  "Wireless",
  "Writing and Editing",
  "Other",
];

export const formDataToJSON = (formData) => {
  let object = {};

  formData.forEach((value, key) => {
    // Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value;
      return;
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]];
    }
    object[key].push(value);
  });

  return object;
};

export const parseJSON = (str) => JSON.parse(str);

export const parseDate = (d) => Date.parse(d);

export const getFormattedTime = (timestamp) => {
  let unix_timestamp = timestamp;

  let date = new Date(parseInt(unix_timestamp));
  // Hours part from the timestamp
  let hours =
    "0" + (date.getHours() > 12 ? date.getHours() - 12 : date.getHours());
  // Minutes part from the timestamp
  let minutes = "0" + date.getMinutes();

  let formattedTime;

  // Will display time in 10:30 am format
  if (date.getHours() >= 12) {
    formattedTime = hours.slice(-2) + ":" + minutes.slice(-2) + " pm";
  } else {
    formattedTime = hours.slice(-2) + ":" + minutes.slice(-2) + " am";
  }

  return formattedTime;
};

export const getFormattedDate = (timestamp, tomorrow = false) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  let unix_timestamp = timestamp;

  let date = new Date(parseInt(unix_timestamp));

  let month = monthNames[date.getMonth()];

  let day = "0" + date.getDate();

  let year = new Date(parseInt(unix_timestamp)).toLocaleString("en-US", {
    year: "numeric",
  });

  let formattedDate;

  if (tomorrow) {
    day = "0" + (date.getDate() + 1);
    formattedDate = day.substr(-2) + " " + month + " " + year;
  } else {
    formattedDate = day.substr(-2) + " " + month + " " + year;
  }

  return formattedDate;
};

export const isOnline = () => {
  return window.navigator.onLine;
};

export const greyFilter =
  "brightness(0%) saturate(100%) invert(93%) sepia(0%) saturate(326%) hue-rotate(139deg) brightness(84%) contrast(93%);";

export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    let val = object[key];
    if (typeof val === "object") {
      val = JSON.stringify(val);
    }
    formData.append(key, val);
  });
  return formData;
}

export const showAlert = (details) => {
  setAlertDetails(details);

  setTimeout(() => setAlertDetails(null), 7000);
};

export const media_base_url =
  "https://postpaddy-s.fra1.digitaloceanspaces.com/Postpaddy";

export function isToday(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();

  return (
    d.getDate() === today.getDate() &&
    d.getMonth() === today.getMonth() &&
    d.getFullYear() === today.getFullYear()
  );
}

export function isTomorrow(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const tomorrow = new Date(today.setDate(today.getDate() + 1));

  return (
    d.getDate() === tomorrow.getDate() &&
    d.getMonth() === tomorrow.getMonth() &&
    d.getFullYear() === tomorrow.getFullYear()
  );
}

export function isLater(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const tomorrow = new Date(today.setDate(today.getDate() + 1));

  return d.getTime() > tomorrow.getTime();
}

export function isYesterday(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const yesterday = new Date(today.setDate(today.getDate() - 1));

  return (
    d.getDate() === yesterday.getDate() &&
    d.getMonth() === yesterday.getMonth() &&
    d.getFullYear() === yesterday.getFullYear()
  );
}

export function isOlder(someDate) {
  if (!someDate) return;

  const d = new Date(parseInt(someDate));
  const today = new Date();
  const yesterday = new Date(today.setDate(today.getDate() - 1));

  return d.getTime() < yesterday.getTime();
}

export function isSameDay(d1, d2) {
  if (!d1 || !d2) return;

  const d = new Date(parseInt(d1));
  const current = new Date(d2);

  return (
    d.getDate() === current.getDate() &&
    d.getMonth() === current.getMonth() &&
    d.getFullYear() === current.getFullYear()
  );
}

export const getFileSize = (size) => {
  return size < 1000
    ? `${size.toFixed(1)} b`
    : size > 1000 && size < 1000 * 1000
    ? `${(size / 1000).toFixed(1)} kb`
    : `${(size / 1000 / 1000).toFixed(1)} mb`;
};

export const formatHashtagAndMention = (text) => {
  let formattedText = [];
  const retLines = text?.split("\n");

  var format = /[ !#@$%^&*()_+\-=[\]{};':"\\|,.<>/?\n]/;

  retLines?.forEach((retLine, index) => {
    const words = retLine.split(" ");
    const contentLength = words.length;

    if (index !== 0) formattedText.push(<br />);
    words.forEach((word, index) => {
      if (
        (word.startsWith("@") && !format.test(word.substr(1))) ||
        (word.startsWith("#") && !format.test(word.substr(1)))
      ) {
        const mention = (
          <span key={`${word}${index}`} className="highlighted">
            {word}
          </span>
        );
        if (index !== contentLength - 1) formattedText.push(mention, " ");
        else formattedText.push(mention);
      } else {
        if (index !== contentLength - 1) return formattedText.push(word, " ");
        else return formattedText.push(word);
      }
    });
  });

  return formattedText;
};

export const mediaIsImage = (path) => /\.(jpe?g|png|gif|bmp)$/i.test(path);
export const mediaIsVideo = (path) => /\.(mp4|mov)$/i.test(path);

export const arrayToFriendlyString = ([...array]) => {
  return array.concat(array.splice(-2, 2).join(" and ")).join(", ");
};

export const formatNumber = (num) => {
  const formatter = new Intl.NumberFormat();
  const toNum = Number(num);

  return formatter.format(toNum);
};

export const toggleModalVisibility = (selector) => {
  if (typeof selector !== "string") return;

  document.querySelector(selector)?.classList.toggle("show");
};

export const capitalizeFirstLetter = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const cloneObj = (obj) => JSON.parse(JSON.stringify(obj));

export const getISODate = (d) => (d ? d.toISOString().split("T")[0] : "");

export const getTimeAgo = (utc_date) => {
  if (!utc_date) return "";

  const d = Date.now();
  const d_notification = Date.parse(utc_date);
  const diff = d - d_notification;
  const years = Math.floor(diff / (12 * 30 * 24 * 60 * 60 * 1000));
  const months = Math.floor(diff / (30 * 24 * 60 * 60 * 1000));
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor(diff / (60 * 60 * 1000));
  const mins = Math.floor(diff / (60 * 1000));
  const secs = Math.floor(diff / 1000);

  if (years >= 1) {
    return `${years} ${years > 1 ? "years" : "year"} ago`;
  } else if (months >= 1) {
    return `${months} ${months > 1 ? "months" : "month"} ago`;
  } else if (days >= 1) {
    return `${days} ${days > 1 ? "days" : "day"} ago`;
  } else if (hours >= 1) {
    return `${hours} ${hours > 1 ? "hours" : "hour"} ago`;
  } else if (mins >= 1) {
    return `${mins} ${mins > 1 ? "mins" : "min"} ago`;
  } else if (secs >= 1) {
    return `${secs} ${secs > 1 ? "seconds" : "second"} ago`;
  }

  return "now";
};

export const getLocaleDateTime = (d) =>
  new Date(d).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

export const extractEmails = (text = "") => {
  return decodeURIComponent(text).match(/([+a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
};

export const checkLinkType = async (linkUrl, cb) => {
  try {
    const response = await fetch(linkUrl, { method: "HEAD" });
    const contentType = response.headers.get("Content-Type");

    if (contentType.includes("video")) {
      cb("video");
    } else if (contentType.includes("image")) {
      cb("image");
    }
  } catch (error) {
    console.error("An error occurred:", error);
  }
};